export default "__VITE_ASSET__CdOoHmNU__"